import Vue from "vue";
import zrTable from "zr-table";
import zrDialog from "zr-dialog";
import zrForm from "zr-form";
import zrIcon from "zr-icon";
import zrEcharts from "zr-echarts";
import zrQueryForm from "zr-base-layout/src/components/layouts/components/ZrQueryForm/export";
Vue.use(zrTable);
Vue.use(zrDialog);
Vue.use(zrForm);
Vue.use(zrIcon);
Vue.use(zrEcharts);
Vue.use(zrQueryForm);
